import { ADMIN, NOVO_REGISTRO_RASCUNHO, ACESSAR_RESUMO, EDITAR_REGISTRO,
  GERENCIADOR_TAREFAS_VISUALIZAR, ACESSAR_REI, CADASTRAR_IMAGENS } from '@/constants/permissions'

/* inicio rotas casamento */

const CasamentoRoutes = [
  {
    path: `/habilitar-casamento/:id`,
    name: 'habilitar_casamento',
    component: () => import('@/views/SofiaRei/Casamento/HabilitacaoCasamento'),
    props: true,
    meta: {
      title: 'Sofia Rei - Habilitação Casamento',
      permissions: [ ADMIN, NOVO_REGISTRO_RASCUNHO ]
    }
  },
  {
    path: `/habilitar-casamento/resumo/:id`,
    name: 'resumo_habilitacao_casamento',
    component: () => import('@/views/SofiaRei/Casamento/ResumoHabilitacaoCasamento'),
    props: true,
    meta: {
      title: 'Sofia Rei - Resumo Habilitação Casamento',
      permissions: [ ADMIN, ACESSAR_RESUMO ]
    }
  },
  {
    path: `/habilitar-casamento/editar/:id`,
    name: 'editar_habilitacao_casamento',
    component: () => import('@/views/SofiaRei/Casamento/EditarHabilitacaoCasamento'),
    meta: {
      title: 'Sofia Rei - Editar Habilitacao Casamento',
      permissions: [ ADMIN, EDITAR_REGISTRO ]
    },
    props: true
  },
  {
    path: `/casamento/:id`,
    name: 'registro_casamento',
    component: () => import('@/views/SofiaRei/Casamento/RegistroCasamento'),
    props: true,
    meta: {
      title: 'Sofia Rei - Registrar Casamento',
      permissions: [ ADMIN, NOVO_REGISTRO_RASCUNHO ]
    }
  },
  {
    path: `/casamento-legado/:id`,
    name: 'registro_casamento_legado',
    component: () => import('@/views/SofiaRei/Casamento/RegistroCasamentoLegado'),
    props: true,
    meta: {
      title: 'Sofia Rei - 2ª Via Casamento',
      permissions: [ ADMIN, NOVO_REGISTRO_RASCUNHO ]
    }
  },
  {
    path: `/casamento/resumo/:id`,
    name: 'resumo_casamento',
    component: () => import('@/views/SofiaRei/Casamento/ResumoCasamento'),
    props: true,
    meta: {
      title: 'Sofia Rei - Resumo Casamento',
      permissions: [ ADMIN, ACESSAR_RESUMO ]
    }
  },
  {
    path: `/casamento/editar/:id`,
    name: 'editar_casamento',
    component: () => import('@/views/SofiaRei/Casamento/EditarCasamento'),
    props: true,
    meta: {
      title: 'Sofia Rei - Editar Casamento',
      permissions: [ ADMIN, EDITAR_REGISTRO ]
    }
  },
  {
    path: '/casamento',
    redirect: '/casamento/novo'
  }
]

const NascimentoRoutes = [
  {
    path: '/nascimento/:idNasc',
    name: 'cadastro_nascimento',
    component: () => import('@/views/SofiaRei/CadastroNascimento'),
    meta: {
      title: 'Sofia Rei - Registrar Nascimento',
      permissions: [ ADMIN, NOVO_REGISTRO_RASCUNHO ]
    },
    props: true
  },
  {
    path: '/nascimento-legado/:idNasc',
    name: 'cadastro_nascimento_legado',
    component: () => import('@/views/SofiaRei/CadastroNascimentoLegado'),
    meta: {
      title: 'Sofia Rei - 2ª Via Nascimento',
      permissions: [ ADMIN, NOVO_REGISTRO_RASCUNHO ]
    }
  },
  {
    path: '/nascimento/edicao/:idNasc',
    name: 'edicao_nascimento',
    component: () => import('@/views/SofiaRei/EdicaoNascimento'),
    meta: {
      title: 'Sofia Rei - Editar Nascimento',
      permissions: [ ADMIN, EDITAR_REGISTRO ]
    },
    props: true
  },
  {
    path: '/nascimento/resumo/:id',
    name: 'resumo_nascimento',
    component: () => import('@/views/SofiaRei/ResumoNascimento'),
    meta: {
      title: 'Sofia Rei - Resumo Nascimento',
      permissions: [ ADMIN, ACESSAR_RESUMO ]
    },
    props: true
  }
]

/* fim rotas casamento */

const RegistroObitoRoutes = [
  {
    path: `/obito/novo`,
    name: 'cadastro_obito',
    component: () => import('@/views/SofiaRei/CadastroObito'),
    meta: {
      title: 'Sofia Rei - Registrar Óbito',
      permissions: [ ADMIN, NOVO_REGISTRO_RASCUNHO ]
    }
  },
  {
    path: `/obito-legado/novo`,
    name: 'cadastro_obito_legado',
    component: () => import('@/views/SofiaRei/CadastroObitoLegado'),
    meta: {
      title: 'Sofia Rei - 2ª via Óbito',
      permissions: [ ADMIN, NOVO_REGISTRO_RASCUNHO ]
    }
  },
  {
    path: `/obito/:id`,
    name: 'editar_obito_rascunho',
    component: () => import('@/views/SofiaRei/CadastroObito'),
    meta: {
      title: 'Sofia Rei - Editar Rascunho Óbito',
      permissions: [ ADMIN, NOVO_REGISTRO_RASCUNHO ]
    }
  },
  {
    path: `/obito-legado/:id`,
    name: 'editar_obito_rascunho_legado',
    component: () => import('@/views/SofiaRei/CadastroObitoLegado'),
    meta: {
      title: 'Sofia Rei - Editar Rascunho Óbito 2ª via',
      permissions: [ADMIN, NOVO_REGISTRO_RASCUNHO]
    }
  },
  {
    path: `/obito/resumo/:id`,
    name: 'resumo_obito',
    component: () => import('@/views/SofiaRei/ResumoObito'),
    meta: {
      title: 'Sofia Rei - Resumo Óbito',
      permissions: [ ADMIN, ACESSAR_RESUMO ]
    },
    props: true
  },
  {
    path: `/obito/editar/:id`,
    name: 'editar_obito',
    component: () => import('@/views/SofiaRei/EditarObito'),
    meta: {
      title: 'Sofia Rei - Editar Registro Óbito',
      permissions: [ ADMIN, EDITAR_REGISTRO ]
    },
    props: true
  },
]

const CrudRoutes = [
  {
    path: '/cadastros/funerarias',
    name: 'cadastro_funerarias',
    component: () => import('@/views/SofiaRei/Funerarias'),
    meta: {
      title: 'Sofia Rei - Funerárias',
    }
  },
  {
    path: '/cadastros/hospitais',
    name: 'cadastro_hospitais',
    component: () => import('@/views/SofiaRei/Hospitais'),
    meta: {
      title: 'Sofia Rei - Hospitais',
    }
  },
  {
    path: '/cadastros/causas-mortes',
    name: 'cadastro_causa_morte',
    component: () => import('@/views/SofiaRei/CausaMorte'),
    meta: {
      title: 'Sofia Rei - Causas Morte',
    }
  },
  {
    path: '/cadastros/locais-de-sepultamento',
    name: 'cadastro_locais_sepultamento',
    component: () => import('@/views/SofiaRei/LocaisSepultamento'),
    meta: {
      title: 'Sofia Rei - Locais Sepultamento',
    }
  },
  {
    path: '/cadastros/solicitantes',
    name: 'cadastro_solicitantes',
    component: () => import('@/views/SofiaRei/Solicitantes'),
    meta: {
      title: 'Sofia Rei - Solicitantes'
    }
  },
  {
    path: '/cadastros/minutas',
    name: 'cadastro_minutas',
    component: () => import('@/views/SofiaRei/Minutas'),
    meta: {
      title: 'Sofia Rei - Minutas'
    }
  },
  {
    path: '/cadastros/natureza-protocolo',
    name: 'cadastro_natureza_protocolo',
    component: () => import('@/views/SofiaRei/NaturezaProtocolo'),
    meta: {
      title: 'Sofia Rei - Natureza Protocolo'
    }
  },
  {
    path: '/cadastros/regime-de-bens',
    name: 'regime_de_bens',
    component: () => import('@/views/SofiaRei/RegimeDeBens'),
    meta: {
      title: 'Sofia Rei - Regime de Bens'
    }
  },
  {
    path: '/cadastros/serventia',
    name: 'cadastro_serventia',
    component: () => import('@/views/SofiaRei/CadastrarServentia'),
    meta: {
      title: 'Sofia Rei - Cadastrar serventia',
    },
    props: true
  },
  {
    path: '/cadastros/custas',
    name: 'acessar_custas',
    component: () => import('@/views/SofiaRei/Custas'),
    meta: {
      title: 'Sofia Rei - Custas',
    }
  },
  // {
  //   path: '/cadastros/inteiro-teor',
  //   name: 'inteiro_teor',
  //   component: () => import('@/views/SofiaRei/InteiroTeor'),
  //   meta: {
  //     title: 'Sofia Rei - Inteiro Teor',
  //   }
  // },
  {
    path: '/ordens-servicos',
    name: 'ordens_servicos',
    component: () => import('@/views/SofiaRei/VisualizaOrdensDeServicos'),
    meta: {
      title: 'Sofia Rei - Ordens de Serviços - Visualizar',
    }
  },
  {
    path: '/ordem-servico/novo',
    name: 'ordem_servico_novo',
    component: () => import('@/components/SofiaRei/Resumo/OrdensServico/OrdemServico.vue'),
    meta: {
      title: 'Sofia Rei - Ordens de Serviços - Novo',
    }
  },
  {
    path: '/ordem-servico/list',
    name: 'ordem_servico_list',
    component: () => import('@/components/SofiaRei/Resumo/OrdensServico/OrdensServicoList.vue'),
    meta: {
      title: 'Sofia Rei - Ordens de Serviços - List',
    }
  },
  {
    path: '/ordem-servico/:id',
    name: 'ordem_servico_editar',
    component: () => import('@/views/SofiaRei/VisualizaOrdemDeServico'),
    meta: {
      title: 'Sofia Rei - Ordens de Serviços - Editar',
    }
  }
]

const RelatorioRoutes = [
  {
    path: '/Relatorios/servicos-realizados-e-recolhimento',
    name: 'relatorio_servicos_realizados_recolhimento',
    component: () => import('@/views/SofiaRei/Relatorios/ServicosRecolhimentos'),
    meta: {
      title: 'Sofia - Relatórios'
    }
  },
  {
    path: '/Relatorios/impressos-seguranca',
    name: 'relatoriosImpressosSeguranca',
    component: () =>  import('@/views/SofiaRei/Relatorios/ImpressosSeguranca/ImpressosSegurancaRelatorios'),
    meta: {
      title: 'Sofia - Relatórios'
    }
  },
  {
    path: '/Relatorios/listagem-registros',
    name: 'relatoriosListagemRegistros',
    component: () => import('@/views/SofiaRei/Relatorios/ListagemRegistros'),
    meta: {
      title: 'Sofia - Relatórios'
    }
  },
  {
    path: '/Relatorios/sefaz-sp',
    name: 'relatoriosSefaz',
    component: () => import('@/views/SofiaRei/Relatorios/Sefaz'),
    meta: {
      title: 'Sofia - Relatórios'
    }
  },
  {
    path: '/Relatorios/policia-federal',
    name: 'relatoriosPoliciaFederal',
    component: () => import('@/views/SofiaRei/Relatorios/PoliciaFederal'),
    meta: {
      title: 'Sofia - Relatórios'
    }
  },
  {
    path: '/Relatorios/Sipet',
    name: 'relatoriosSipet',
    component: () => import('@/views/SofiaRei/Relatorios/Sipet'),
    meta: {
      title: 'Sofia - Relatórios'
    }
  },
  {
    path: '/Relatorios/ministerio-defesa',
    name: 'relatoriosMinisterioDefesa',
    component: () => import('@/views/SofiaRei/Relatorios/MinisterioDefesa'),
    meta: {
      title: 'Sofia - Relatórios'
    }
  },
  {
    path: '/Relatorios/relatorio-selos',
    name: 'relatorioSelos',
    component: () => import('@/views/SofiaRei/Relatorios/Selos'),
    meta: {
      title: 'Sofia - Relatórios'
    }
  },
  {
    path: '/Relatorios/cumprimento-pedidos',
    name: 'cumprimentoPedidos',
    component: () => import('@/views/SofiaRei/Relatorios/CumprimentoPedidos'),
    meta: {
      title: 'Sofia - Relatórios'
    }
  }
]

const PapelSegurancaRoutes = [
  {
    path: '/papel-seguranca',
    component: () =>  import('@/views/SofiaRei/PapelSeguranca'),
    meta: {
      title: 'Sofia Rei - Papel Segurança'
    },
    children: [
      {
        path: '',
        name: 'papel_seguranca_lote',
        component: () =>  import('@/views/SofiaRei/PapelSeguranca/PapelSegurancaLote'),
        meta: {
          title: 'Sofia Rei - Papel Segurança Lote',
          permissions: [ ADMIN ]
        },
        props: true
      },
      {
        path: 'lote/:id',
        name: 'papel_seguranca_lote_detalhes',
        component: () =>  import('@/views/SofiaRei/PapelSeguranca/PapelSegurancaLoteDetalhes'),
        meta: {
          title: 'Sofia Rei - Papel Segurança lote detalhes',
          permissions: [ ADMIN ]
        },
        props: true
      }
    ]
  }
]

const ProtocolosRoutes = [
  {
    path: '/protocolos',
    component: () =>  import('@/views/SofiaRei/Protocolos'),
    children: [
      {
        path: '',
        name: 'protocolos',
        component: () => import('@/views/SofiaRei/Protocolos/ProtocolosLista'),
        meta: {
          title: 'Sofia Rei - Protocolos',
          permissions: [ADMIN]
        },
        props: true
      },
      {
        path: ':id/detalhes',
        name: 'protocolos_detalhes',
        component: () => import('@/views/SofiaRei/Protocolos/ProtocolosDetalhes'),
        meta: {
          title: 'Sofia Rei - Protocolo andamento',
          permissions: [ADMIN]
        },
        props: true
      },
      {
        path: 'imprimir',
        name: 'protocolos_imprimir',
        component: () => import('@/views/SofiaRei/Protocolos/ProtocolosImprimir'),
        meta: {
          title: 'Sofia Rei - Imprimir Protocolos',
          permissions: [ADMIN]
        },
        props: true
      }
    ]
  }
]

const ImportarEmLote = [
  {
    path: '/importar-imagens-em-lote',
    component: () =>  import('@/views/SofiaRei/ImportarImagensEmLote'),
    children: [
      {
        path: '',
        name: 'importar_imagens_em_lote',
        component: () => import('@/views/SofiaRei/ImportarImagensEmLote/InicioImportacaoImagensEmLote'),
        meta: {
          title: 'Sofia Rei - Importar imagens em Lote',
          permissions: [ADMIN, CADASTRAR_IMAGENS]
        },
        props: false
      },
      {
        path: 'livro/:id',
        name: 'lote_livro',
        component: () => import('@/views/SofiaRei/ImportarImagensEmLote/FimImportacaoImagensEmLote'),
        meta: {
          title: 'Sofia Rei - Lote por Livro',
          permissions: [ADMIN, CADASTRAR_IMAGENS]
        },
        props: false
      },
      {
        path: 'registro',
        name: 'lote_registro',
        component: () => import('@/views/SofiaRei/ImportarImagensEmLote/FimImportacaoImagensEmLote'),
        meta: {
          title: 'Sofia Rei - Lote por Registro',
          permissions: [ADMIN, CADASTRAR_IMAGENS]
        },
        props: false
      }
    ]
  }
]

const FrenteDeCaixaRoutes = [
  {
    path: '/frente-de-caixa/caixa',
    name: 'FrenteDeCaixa',
    component: () => import('@/views/SofiaRei/FrenteDeCaixa/FrenteDeCaixa'),
    meta: {
      title: 'Sofia - Frente de Caixa',
      loginRequired: true
    }
  },
  {
    path: '/fechamento-frente-de-caixa',
    name: 'FechamentoFrenteCaixa',
    component: () => import('@/views/SofiaRei/FrenteDeCaixa/Fechamento/FechamentoFrenteDeCaixa'),
    meta: {
      title: 'Sofia - Fechamento de caixa',
      loginRequired: true
    }
  },
]

const MensalistasRoutes = [
  {
    path: '/mensalistas/cadastro-de-mensalistas',
    name: 'Mensalistas',
    component: () => import('@/views/SofiaRei/FrenteDeCaixa/Mensalistas/Mensalistas'),
    meta: {
      title: 'Sofia - Fechamento de caixa',
      loginRequired: true
    }
  },
  {
    path: '/mensalistas/servicos-realizados',
    name: 'Mensalistas Serviços Realizados',
    component: () => import('@/views/SofiaRei/FrenteDeCaixa/Mensalistas/ServicosRealizados/ServicosRealizados'),
    meta: {
      title: 'Sofia - Mensalistas Serviços Realizados',
      loginRequired: true
    }
  },
  {
    path: '/mensalistas/pagamentos-faturados',
    name: 'Mensalistas Serviços Faturados',
    component: () => import('@/views/SofiaRei/FrenteDeCaixa/Mensalistas/PagamentosFatutados/PagamentosFatutados'),
    meta: {
      title: 'Sofia - Mensalistas Serviços Faturados',
      loginRequired: true
    }
  },
]

const ReleasesNotes = [
  {
    path: `/releases-notes/last-updates`,
    name: 'latest-release-updates',
    component: () => import('@/components/SofiaRei/ReleasesNotes/LastUpdates'),
    props: true,
    meta: {
      title: 'Sofia Rei - Latest Release Updates',
      permissions: [ ADMIN ]
    }
  },
  {
    path: `/releases-notes/:id`,
    name: 'releases-notes',
    component: () => import('@/views/SofiaRei/ReleasesNotes/ReleasesNotes'),
    props: true,
    meta: {
      title: 'Sofia Rei - Releases Notes',
      permissions: [ ADMIN ]
    }
  }
]

const ONRCPNRoutes = [
  {
    path: '/onrcpn/integracoes',
    name: 'onrcpn-integracoes',
    component: () => import('@/components/SofiaRei/Onrcpn/Integracoes/Integracoes'),
    props: true,
    meta: {
      title: 'Integrações ON-RCPN',
      permissions: [ ADMIN ]
    }
  },
  {
    path: '/onrcpn/integracoes/formulario',
    name: 'onrcpn-integracoes-formulario',
    component: () => import('@/components/SofiaRei/Onrcpn/Integracoes/Formulario'),
    props: true,
    meta: {
      title: 'Formulário de Integrações ON-RCPN',
      permissions: [ ADMIN ]
    }
  }
]

export const reiRoutes = [
  ...NascimentoRoutes,
  ...CasamentoRoutes,
  ...RegistroObitoRoutes,
  ...CrudRoutes,
  ...RelatorioRoutes,
  ...PapelSegurancaRoutes,
  ...ProtocolosRoutes,
  ...ImportarEmLote,
  ...FrenteDeCaixaRoutes,
  ...MensalistasRoutes,
  ...ReleasesNotes,
  ...ONRCPNRoutes,

  {
    path: '/',
    name: 'rei_dashboard',
    component: () => import('@/views/SofiaRei/Dashboard'),
    meta: {
      title: 'Sofia Rei - Dashboard',
    }
  },
  {
    path: '/visualizar-documentos/:id/:origem',
    name: 'sofia_rei_docs',
    component: () => import('@/views/SofiaRei/VisualizarArquivos'),
    meta: {
      title: 'Sofia Rei - Visualizador de Arquivos',
    }
  },
  {
    path: '/acessar-cartorio',
    name: 'acessar_cartorio',
    component: () => import('@/views/AcessarCartorio'),
    meta: {
      title: 'Sofia - Acessar cartório',
      loginRequired: true,
      permissions: [ ADMIN, ACESSAR_REI]
    }
  },
  {
    path: '/editar-senha',
    name: 'editarSenha',
    component: () => import('@/views/EditarSenha'),
    meta: {
      title: 'Sofia - Alterar senha',
      loginRequired: true
    }
  },
  {
    path: '/administracao-sistema',
    name: 'administracaoSistema',
    component: () => import('@/views/AdministracaoSistema'),
    meta: {
      title: 'Sofia - Administração do Sistema',
      loginRequired: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login'),
    meta: {
      title: 'Sofia - Login',
    }
  },
  {
    path: '/primeiro-acesso',
    name: 'wizard',
    component: () => import('@/views/Wizard'),
    meta: {
      title: 'Sofia - Primeiro Acesso'
    }
  },
  {
    path: '/gerenciador',
    name: 'gerenciador',
    component: () => import('@/views/SofiaRei/Gerenciador'),
    meta: {
      title: 'Sofia - Gerenciador de tarefas',
      permissions: [ ADMIN, GERENCIADOR_TAREFAS_VISUALIZAR]
    },
    props: true
  },
  {
    path: '/pagina-nao-encontrada/:id',
    name: 'pageNotFound',
    component: () => import('@/views/PageNotFound'),
    meta: {
      title: 'Sofia - Página não encontrada'
    }
  },
  {
    path: '/atendimento',
    name: 'Atendimento',
    component: () => import('@/views/SofiaRei/Atendimento'),
    meta: {
      title: 'Sofia - Atendimento',
      loginRequired: false
    }
  },
  {
    path: '/administracao/selos-os-cancelados',
    name: 'selosEOSCancelados',
    component: () => import('@/views/SofiaRei/SelosEOSCancelados'),
    meta: {
      title: 'Sofia - Selos e OS Cancelados',
      loginRequired: true
    }
  },
  {
    path: '/livro-caixa',
    name: 'livroCaixa',
    component: () => import('@/views/SofiaRei/LivroCaixa'),
    meta: {
      title: 'Sofia - Livro Caixa',
      loginRequired: true
    }
  },
  {
    path: '/cadastros/categorias',
    name: 'categoriasEAtos',
    component: () => import('@/views/SofiaRei/CategoriasEAtos'),
    meta: {
      title: 'Sofia - Categorias e Tipo de Ato',
      loginRequired: true
    }
  },
  {
    path: '/cadastros/beneficiarios',
    name: 'Beneficiarios',
    component: () => import('@/views/SofiaRei/Beneficiarios'),
    meta: {
      title: 'Sofia - Beneficiários',
      loginRequired: true
    }
  },
  {
    path: '/icp',
    name: 'LoginICP',
    component: () => import('@/views/LoginAlternativo'),
    meta: {
      title: 'Sofia - Login',
    }
  },
  {
    path: '/eProtocolo-pendencia',
    name: 'Pendencia',
    component: () => import('@/views/SofiaRei/EProtocolo/Pendencia'),
    meta: {
      title: 'Sofia - Pendência e-Protocolo',
      loginRequired: true
    }
  },
  {
    path: '/eProtocolo-arquivos-estruturados',
    name: 'ArquivosEstruturados',
    component: () => import('@/views/SofiaRei/EProtocolo/ArquivosEstruturados'),
    meta: {
      title: 'Sofia - Arquivos Estruturados e-Protocolo',
      loginRequired: true
    }
  }
]

